import React from 'react';

function CollapsibleItem({ title, icon, innerContent }) {
  return (
    <li>
      <div className="collapsible-header"><i className="material-icons">{icon}</i>{title}</div>
      <div className="collapsible-body">{innerContent()}</div>
    </li>
  )
}

export default CollapsibleItem;